<template>
  <div class="container">
    <h2
      name="faq"
      class="title my-size-4 text-size-4 tablet:my-size-2 tablet:text-size-3"
    >
      {{ paragraphTitle }}
    </h2>
    <ParagraphFAQQuestion
      v-for="question in questions"
      :id="question.id"
      :key="question.id"
      :name="question.name"
      :answer="question.answer"
      :link="questionLink(question)"
    />
  </div>
</template>

<script setup lang="ts">
import type { ParagraphFaqFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const props = defineProps<{
  id?: ParagraphFaqFragment['id']
  title?: ParagraphFaqFragment['title']
  category?: ParagraphFaqFragment['category']
  questions?: ParagraphFaqFragment['questions']
}>()

defineBlokkli({
  bundle: 'faq',
})
const { $texts } = useEasyTexts()

const questions = computed(() => filterNullArray(props.questions))

const paragraphTitle = computed(() => {
  if (props.title) {
    return `${props.title} ${props.category?.[0]?.name}`
  }
  return `${$texts('faq')} ${props.category?.[0]?.name}`
})

// Transform the link structure to match what Question.vue expects
function questionLink(
  question: NonNullable<ParagraphFaqFragment['questions']>[number],
) {
  if (!question?.link) {
    return undefined
  }
  return {
    url: { path: question.link.path },
    title: question.link.title,
  }
}
</script>
